import { render, staticRenderFns } from "./RedirectLocationDropdown.vue?vue&type=template&id=73ff70e7&"
import script from "./RedirectLocationDropdown.vue?vue&type=script&lang=js&"
export * from "./RedirectLocationDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports